// Import required libraies
import React, { useState } from "react";
import { useHistory } from "react-router";
import { connect } from "react-redux";

// Import Custom Component
import SigviewTextField from "../../../components/Common/SigviewTextField";
import SigviewButton from "../../../components/Common/SigviewButton";
import SigviewSimpleText from "../../../components/Common/SigviewSimpleText";

// Import action creators
import { updateUserScreen } from "../../../redux/actions";

// Import utils/data
import { validateChartName } from "../../../utils/chartObjectUtils";

// Import API functions
import { checkWorksheetName, renameWorksheet } from "../../../services/api";

function SigviewDialogWorkspaceNameChange(props) {
  const {
    user,
    ReduxDispatcher,
    initialName,
    worksheetId,
    workbookId,
    setReloadWorkbooks,
  } = props;

  // Defining required state
  const [name, setName] = useState({
    value: initialName,
    status: "success", // success/error/loading
    message: "",
  });
  const history = useHistory();

  // Making required variables

  // Defining required event handlers
  const handleNameChange = (newValue) => {
    setName(() => {
      const { status, message } = validateChartName(newValue);
      let finalStatus = "success";
      if (status === "invalid") finalStatus = "error";
      const newState = { status: finalStatus, message, value: newValue };
      return newState;
    });
  };
  const handleCancel = () => {
    const payload = { open: false, children: null };
    const action = updateUserScreen("sigviewDialog", payload);
    ReduxDispatcher(action);
  };

  // Defining required variables
  const errorFlag = name.status === "error";
  const helperText = name.message;
  const cloneDisabled = ["error", "loading"].includes(name.status);

  // WS Name (UI)
  const [wsName, setWsName] = useState({
    status: "success",
    value: user?.screen?.activeWorkspace?.payload?.worksheet?.sheetName,
    originalValue: user?.screen?.activeWorkspace?.payload?.worksheet?.sheetName,
    message: "",
  });
  const handleSnackbarMessageShow = (message) => {
    let snackbarPayload = {
      ...user.screen.snackbar,
      open: true,
      message: message,
    };
    const action = updateUserScreen("snackbar", snackbarPayload);
    ReduxDispatcher(action);
  };

  const handleNameChangeClickAway = () => {
    // Google Analytics Event - Master
    // masterTrackGaEvent({
    //   category: "DatastoryDashboard",
    //   action: "Rename",
    //   label: "DS",
    // });

    // Making required active variables
    //If entered wsName is invalid
    const { status, message } = validateChartName(name.value);
    if (status === "invalid") {
      setWsName((prevState) => ({
        ...prevState,
        status: "success",
        value: prevState.originalValue,
      }));
      handleSnackbarMessageShow(message);
    } else {
      // Do this only when the names are different otherwise
      // it will run for every click on the screen
      if (name.value !== initialName) {
        // Make an API call only when the element type is update

        setWsName((prevState) => ({ ...prevState, status: "loading" }));
        const fetchPayload = {
          workbookId: workbookId,
          worksheetName: name.value,
        };
        const fetchProps = {
          payload: fetchPayload,
        };
        const checkWoksheetNamePromise = checkWorksheetName(fetchProps);
        checkWoksheetNamePromise
          .then((responseData) => {
            // Worksheet name exits
            if (!responseData.result.data.status) {
              const fetchPayload = {
                emailId: user?.reqMetadata?.email,
                workbookId: workbookId,
                worksheetId: worksheetId,
                worksheetName: name.value,
              };
              const fetchProps = {
                payload: fetchPayload,
              };
              const renameWorksheetPromise = renameWorksheet(fetchProps);
              renameWorksheetPromise
                .then((responseData) => {
                  setWsName((prevState) => ({
                    ...prevState,
                    status: "success",
                    originalValue: prevState.value,
                  }));
                  handleSnackbarMessageShow("Name updated successfully!");
                  handleCancel();
                  history.push("/workspace");
                  setReloadWorkbooks(Date.now());
                })
                .catch((json) => {
                  console.groupCollapsed("API FAILED");
                  console.log("Error JSON -> ", json);
                  console.groupEnd();
                  setWsName((prevState) => ({
                    ...prevState,
                    status: "success",
                    value: prevState.originalValue,
                  }));
                  handleSnackbarMessageShow(json.error || "Rename Failed");
                });
            } else {
              setWsName((prevState) => ({
                ...prevState,
                status: "success",
                value: prevState.originalValue,
              }));
              handleSnackbarMessageShow("Workspace name already exists!");
            }
          })
          .catch((json) => {
            console.groupCollapsed("API FAILED");
            console.log("Error JSON -> ", json);
            console.groupEnd();
            setWsName((prevState) => ({
              ...prevState,
              status: "success",
              value: prevState.originalValue,
            }));
            handleSnackbarMessageShow(json.error || "Rename Failed");
          });
      }
    }
  };

  return (
    <section className="sigview-dialog-chart-clone">
      <SigviewSimpleText
        value="Edit Workspace name"
        style={{
          border: "none",
          fontSize: "16px",
          margin: "0px 0px 15px 0px",
          padding: "0px",
        }}
      />
      <SigviewTextField
        placeholder="Please enter a valid chart name..."
        value={name.value}
        onChange={(newValue) => handleNameChange(newValue)}
        error={errorFlag}
        helperText={helperText}
        minWidth="400px"
        maxWidth="400px"
        height="40px"
        margin={{ right: "5px", bottom: "10px" }}
      />
      <article className="sigview-dialog-chart-clone-menu-bar">
        <SigviewButton
          variant="outlined"
          onClick={handleCancel}
          title="Cancel"
          style={{ width: "auto", margin: { left: "3px", right: "3px" } }}
        />
        <SigviewButton
          variant="contained"
          onClick={() => handleNameChangeClickAway()}
          disabled={cloneDisabled}
          customClassName="PivotClone-GA"
          title="Save"
          style={{ width: "auto", margin: { left: "3px", right: "3px" } }}
        />
      </article>
    </section>
  );
}
SigviewDialogWorkspaceNameChange.propTypes = {};

const mapStateToProps = (state) => ({
  user: state.user,
  allData: state.data,
  standaloneWs: state.standaloneWs,
  globalFilters: state.globalFilters,
});

export default connect(mapStateToProps)(SigviewDialogWorkspaceNameChange);
